import { createSelector } from 'reselect';

const getChecksumData = (state: any) => state.checksumReducer.data;
const getTotalChecksumItemsData = (state: any) => state.checksumReducer.totalNumberOfElements;
const getChecksumPagingInfoData = (state: any) => state.checksumReducer.pagingInfo;
const getChecksumLoadingData = (state: any) => state.checksumReducer.loading;
const getChecksumHashAlgorithmsData = (state: any) => state.checksumReducer.hashAlgorithms;

export const getChecksum = createSelector(getChecksumData, (state) => state);
export const getTotalChecksumItems = createSelector(getTotalChecksumItemsData, (state) => state);
export const getChecksumPagingInfo = createSelector(getChecksumPagingInfoData, (state) => state);
export const getChecksumLoading = createSelector(getChecksumLoadingData, (state) => state);
export const getChecksumHashAlgorithms = createSelector(getChecksumHashAlgorithmsData, (state) => state);